import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../components/SVGIcon';
import Timestamp from '../components/Timestamp';
import Tooltip from '../components/Tooltip';
import popularityHighIcon from '../icons/non-prefilled/16x16/popularityHigh.svg';
import popularityLowIcon from '../icons/non-prefilled/16x16/popularityLow.svg';
import popularityMediumIcon from '../icons/non-prefilled/16x16/popularityMedium.svg';
import * as styles from './PostRowMeta.module.scss';
import useLayoutSize, { LayoutSize } from './utils/useLayoutSize';

type MetaAttributeMap = {
  publishedAt: string;
  updatedAt: string;
  userViewedAt: string;
  insertedAt: string;
  popularity: number;
  editedAt: string;
  viewedAt: string;
};

interface MetaProps<Attribute extends keyof MetaAttributeMap> {
  attribute: Attribute;
  values: Pick<MetaAttributeMap, Attribute>;
}

const PostRowMeta = <Attribute extends keyof MetaAttributeMap>(
  props: MetaProps<Attribute>,
) => {
  const layoutSize = useLayoutSize();
  const isMobile = layoutSize === LayoutSize.mobile;
  const mappedValue = props.values[props.attribute];

  if (props.attribute === 'popularity') {
    let popularityIcon = popularityHighIcon;
    if (typeof mappedValue !== 'number' || mappedValue < 10) {
      popularityIcon = popularityLowIcon;
    } else if (mappedValue < 100) {
      popularityIcon = popularityMediumIcon;
    }
    return (
      <Tooltip
        asChild
        content={
          <>
            {mappedValue ?? 0} views
            <br />
            <Tooltip.Muted>Last 90 days</Tooltip.Muted>
          </>
        }
      >
        <SVGIcon
          className={classNames(styles.metaPopularity, {
            [styles.mobile]: isMobile,
          })}
        >
          {popularityIcon}
        </SVGIcon>
      </Tooltip>
    );
  }
  return (
    <div
      className={classNames(styles.metaTime, {
        [styles.mobile]: isMobile,
      })}
    >
      {!!mappedValue && (
        <Timestamp format={isMobile ? 'minimal' : 'short'} date={mappedValue} />
      )}
    </div>
  );
};

export default PostRowMeta;
